import React from 'react';
// @ts-expect-error
import {Swiper, SwiperSlide} from 'swiper/react';
// @ts-expect-error
import {Swiper as SwiperClass} from 'swiper/types';
import 'swiper/swiper.min.css';
import Product from './Product.client';
import clsx from 'clsx';
interface Props {
  children?: React.ReactNode;
  products: ProductWithNodes[];
}

//types
import type {ProductWithNodes} from '../../types';

export default function Carousel({products}: Props) {
  const swiperRef = React.useRef<SwiperClass>(null);
  const SwiperCarousel: SwiperClass = Swiper;
  return (
    <div className="relative px-6 lg:px-0">
      <SwiperCarousel
        breakpoints={{
          320: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
          1024: {
            spaceBetween: 40,
            slidesPerView: 5,
          },
        }}
        loop={true}
        ref={swiperRef}
      >
        {products &&
          products.map((product) => (
            <SwiperSlide key={product.id}>
              <Product storefrontProduct={product} />
            </SwiperSlide>
          ))}
      </SwiperCarousel>
      <button
        onClick={() => swiperRef.current?.swiper.slidePrev()}
        className={clsx(
          'absolute left-0 top-1/2 z-10  -translate-y-1/2 -translate-x-2 lg:-translate-x-10',
          products && products?.length < 4 && 'lg:hidden',
          products && products?.length < 3 && 'hidden',
        )}
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="rotate-90"
        >
          <path
            d="M9.75 4.5L6 8.25L2.25 4.5"
            stroke="#3A3E3E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        onClick={() => swiperRef.current?.swiper.slideNext()}
        className={clsx(
          'absolute right-0 top-1/2 z-10 -translate-y-1/2 translate-x-2 lg:translate-x-10',
          products && products?.length < 4 && 'lg:hidden',
          products && products?.length < 3 && 'hidden',
        )}
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="-rotate-90"
        >
          <path
            d="M9.75 4.5L6 8.25L2.25 4.5"
            stroke="#3A3E3E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}
